<template>
  <div class="">
    <ZnBreadcrumb></ZnBreadcrumb>
    <div class="main-content">
      <div class="search-type">
        <ul class="clearfix">
          <li>
            <!-- <img src="../../assets/images/searchIcon.png" alt=""/>
            <input
                type="text"
            /> -->
            <div class="search-wrapper">
              <el-input
                v-model="searchData.accountName"
                placeholder="请输入关键字"
                @keyup.enter.native ="getLockerSchoolTask"
              />
  
              <el-button size="small" type="primary" class="cursorPointer" @click="getLockerSchoolTask">
                快速查询
              </el-button>
            </div>
            <div class="btn-wrapper" style="margin-right: 15%">
              <el-button @click="batchEdit('capitaPrice')">
                一键修改年度限额
              </el-button>
              <el-button type="primary" @click="batchEdit('price')">
                一键修改单个限额
              </el-button>
            </div>
          </li>
        </ul>
      </div>
      <div class="goods-info">
        <el-table
          :row-class-name="tableRowIndex"
          :data="userList"
          :header-cell-style="{
            background: '#F8FAFC',
            color: 'rgba(0, 0, 0, 0.85)',
            fontWeight: 700,
            height: '54px',
          }"
          border
          style="width: 85%"
        >
          <template slot="empty">
            <img src="../../assets/images/empty.png" class="empty" />
            <p>暂无操作记录</p>
          </template>
          <el-table-column prop="id" label="账号ID"></el-table-column>
          <el-table-column prop="accountName" label="账号"></el-table-column>
          <el-table-column prop="nickName" label="真实姓名"></el-table-column>
          <el-table-column
            prop="usedPrice"
            label="本年度已用额度"
          ></el-table-column>
          <el-table-column
            label="本年度剩余额度"
            :formatter="formatterPrice"
          ></el-table-column>
          <el-table-column prop="capitaPrice" label="年度试剂购买限额">
            <template slot-scope="scop">
              <el-input
                v-model="scop.row.capitaPrice"
                style="width: 100px; height: 10px"
                type="number"
                min="0"
                :ref="'Input_'+scop.$index"
                :disabled="scop.row.upd!=true"
                @change="saveCapitaPrice(scop.row)"
                @blur="scop.row.upd=false"
                @input="(val) => onInputNum(val)"
              ></el-input>
              <!--              <el-button type="text" style="margin-left: 10px" size="small" @click="updateCapitaPrice(scop.row)">修改</el-button>-->
              <el-button
                type="text"
                style="margin-left: 10px"
                size="small"
                @click="updPriceClick(scop.row)"
                v-if="scop.row.upd==false"
                >修改</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单个试剂购买限额">
            <template slot-scope="scop">
              <el-input
                type="number"
                style="width: 100px; height: 10px"
                :ref="'Input2_'+scop.$index"
                @input="handleStockRadio('thirdSalesTask')"
                @change="savePrice(scop.row)"
                @blur="scop.row.upd2=false"
                :disabled="scop.row.upd2!=true"
                v-model="scop.row.price"
              ></el-input>
              <!--              <el-button type="text" style="margin-left: 10px" size="small" @click="updatePrice(scop.row)">修改</el-button>-->
              <el-button
                type="text"
                style="margin-left: 10px"
                size="small"
                @click="upd2PriceClick(scop.row)"
                v-if="scop.row.upd2==false"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :dataTotal="pagedata.total"
          :page-size="searchData.pageSize"
          @changePage="changePage"
        ></Pagination>
      </div>
    </div>
    <el-dialog
      :title="titleContent"
      :visible.sync="batchEditDisabled"
      width="460px"
    >
      <el-input v-model="batchEditValue" type="number"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchEditDisabled = false">取 消</el-button>
        <el-button type="primary" @click="handleBatchEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchData: {
        accountName: "",
        checkEnabled: 1,
        pageNum: 1,
        pageSize: 10,
      },
      alias: "",
      pagedata: {
        total: null,
        totalpage: null,
      },
      userList: [],
      dis: true,
      ruleForm: {
        thirdSalesTask: "0",
      },
      capitaPriceDisabled: "",
      priceDisabled: "",
      batchEditDisabled: false,
      batchEditValue: "",
      titleContent: "",
    };
  },
  created() {
    this.getLockerSchoolTask();
  },
  methods: {
    tableRowIndex({row, rowIndex}) {
      row.index = rowIndex;
    },
    formatterPrice(row) {
      if (
        row.usedPrice == undefined ||
        row.capitaPrice == undefined ||
        row.capitaPrice - row.usedPrice < 0
      ) {
        return 0;
      }

      return Math.floor((row.capitaPrice - row.usedPrice) * 100) / 100;
    },
    handleBatchEdit() {
      if (this.titleContent == "一键修改年度限额") {
        if (this.batchEditValue == "") {
          return this.$message.warning("请输入人均年度限额");
        }
        for (let i = 0; i < this.userList.length; i++) {
          if (this.batchEditValue < this.userList[i].originPrice){
            return this.$message.error(`${this.userList[i].id}用户年度试剂购买限额不能小于单个试剂购买限额`);
          }
        }
        this.$apiFetch
          .post(`/lockerCapitaAstrict/batchEdit`, {
            capitaPrice: this.batchEditValue,
          })
          .then((res) => {
            if (res.status == 200) {
              this.batchEditDisabled = false;
              this.$message.success("一键修改年度限额成功");
              this.getLockerSchoolTask();
            }
          });
      } else {
        if (this.batchEditValue == "") {
          return this.$message.warning("请输入单个试剂限额");
        }
        for (let i = 0; i < this.userList.length; i++) {
          if (this.batchEditValue > this.userList[i].originCapitaPrice){
            return this.$message.error(`${this.userList[i].id}用户单个试剂购买限额不能大于年度试剂购买限额`);
          }
        }
        this.$apiFetch
          .post(`/lockerCapitaAstrict/batchEdit`, {
            price: this.batchEditValue,
          })
          .then((res) => {
            if (res.status == 200) {
              this.batchEditDisabled = false;
              this.$message.success("一键修改单个限额成功");
              this.getLockerSchoolTask();
            }
          });
      }
    },
    batchEdit(flag) {
      if (flag == "capitaPrice") {
        this.titleContent = "一键修改年度限额";
      } else {
        this.titleContent = "一键修改单个限额";
      }
      this.batchEditValue = "";
      this.batchEditDisabled = true;
    },
    updateCapitaPrice(row) {
      this.capitaPriceDisabled = row.id + "capitaPrice";
    },
    updatePrice(row) {
      this.priceDisabled = row.id + "price";
    },
    saveCapitaPrice(row) {
      if(row.upd !=true){
        row.upd = true;
        this.$nextTick(() => {
          this.$refs['Input_'+row.index].focus();
        })
        return;
      }
      if(row.capitaPrice<row.originPrice){
        row.capitaPrice = row.originCapitaPrice
        return this.$message.error("年度试剂购买限额不能小于单个试剂购买限额");
      }
      this.$apiFetch
        .put(`/lockerCapitaAstrict`, {
          capitaPrice: row.capitaPrice,
          userId: row.id,
        })
        .then((res) => {
          if (res.status == 200  && res.data.code!=418) {
            this.$message.success("更新成功");
            this.getLockerSchoolTask();
          } else {
            this.getLockerSchoolTask();
            this.$message.error("更新失败:"+res.data.description);
          }
        }).catch((error)=>{
        this.$message.error("更新失败:"+error.data.msg);
      });
      this.capitaPriceDisabled = "";
    },
    savePrice(row) {
      // console.log("单个试剂额度（修改后/修改前）",row.price,row.originPrice,"年度试剂额度（修改后/修改前）",row.capitaPrice,row.originCapitaPrice)
      if (row.price >row.originCapitaPrice){
        row.price = row.originPrice
        return this.$message.error("单个试剂购买限额不能大于年度试剂购买限额");
      }
      this.$apiFetch
        .put(`/lockerCapitaAstrict`, { price: row.price, userId: row.id })
        .then((res) => {
          if (res.status == 200 && res.data.code!=418) {
            this.$message.success("更新成功");
            this.getLockerSchoolTask();
          } else {
            this.getLockerSchoolTask();
            this.$message.error("更新失败:"+res.data.description);
          }
        }).catch((error)=>{
        this.$message.error("更新失败:"+error.data.msg);
      });
      this.priceDisabled = "";
    },
    upd2PriceClick(row){
      if(row.upd2 !=true){
        row.upd2 = true;
        this.$nextTick(() => {
          this.$refs['Input2_'+row.index].focus();
        })
        return;
      }
    },
    updPriceClick(row){
      if(row.upd !=true){
        row.upd = true;
        this.$nextTick(() => {
          this.$refs['Input_'+row.index].focus();
        })
        return;
      }
    },

    handleStockRadio(field) {
      this.ruleForm[field] = this.ruleForm[field].replace(/[^\d.]/g, ""); // 清除"数字"和"."以外的字符
      this.ruleForm[field] = this.ruleForm[field].replace(/^\./g, ""); // 验证第一个字符是数字
      this.ruleForm[field] = this.ruleForm[field].replace(/\.{2,}/g, "."); // 只保留第一个, 清除多余的
      this.ruleForm[field] = this.ruleForm[field]
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.ruleForm[field] = this.ruleForm[field].replace(
        // eslint-disable-next-line no-useless-escape
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      ); // 只能输入两个小数
      if (
        field != "totalSalesTask" &&
        field != "firstSalesTask" &&
        field != "secondSalesTask" &&
        field != "thirdSalesTask"
      ) {
        if (this.ruleForm[field] > 100) {
          this.ruleForm[field] = 100;
        }
      }

      if (this.ruleForm[field] < 0) {
        this.ruleForm[field] = 0;
      }
    },

    onInputNum(value) {
      if (value.length > 8) {
        value = value.slice(0, 8);
        this.limit = value;
      }
    },

    getLockerSchoolTask() {
      let params = this.searchData;
      this.$apiFetch.get(`/lockerUser/queryUserList`, params).then((res) => {
        this.pagedata = {
          total: res.data.total,
          totalpage: res.data.pages,
        };
        this.userList = res.data.list;
        this.userList.forEach(item=>{
          item.originPrice = item.price;
          item.originCapitaPrice = item.capitaPrice
          this.$set(item,'upd',false)
          this.$set(item,'upd2',false)
        })
      });
    },

    changePage(data) {
      this.searchData.pageNum = data;
      this.getLockerSchoolTask();
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  background-color: #ffffff;
}

.placeDia {
  ul {
    li {
      padding-top: 20px;
      display: flex;

      label {
        display: block;
        color: #666666;
        font-size: 14px;
        width: 25%;
        line-height: 41px;
      }

      input {
        border-bottom: 1px solid #cccccc;
        font-size: 14px;
        line-height: 40px;
        width: 100%;
        color: #333333;
      }

      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #ccc;
      }

      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ccc;
      }

      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ccc;
      }

      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #ccc;
      }
    }

    li:first-child {
      padding-top: 0;
    }
  }

  .locking {
    width: 100%;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #478aff;
    border-radius: 4px;
    border: 1px solid #478aff;
    background-color: #ffffff;
    margin-top: 25px;
  }

  span.tips {
    color: #ff4d4f;
    padding-top: 6px;
    text-align: center;
    display: block;
  }
}

/deep/ .el-table {
  margin-top: 20px;
  border-radius: 4px 4px 0 0;

  img.empty {
    width: 196px;
    margin-top: 38px;
  }

  button.forbid {
    color: #ff4d4f;
  }

  span.nomal {
    padding-left: 10px;
  }

  span.disabled {
    padding-left: 10px;
  }

  .nomal::before {
    width: 5px;
    height: 5px;
    background: #52c41a;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 28px;
  }

  span.disabled::before {
    background-color: #ff4d4f;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 30px;
  }
}

.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;

  ul {
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .search-wrapper{
        .el-input{
          margin-right: var(--zng-gap);
          width: 220px;
        }
      }
    }
  }
}

.goods-info {
  padding: 20px;
  background-color: #ffffff;
}

/deep/ .right {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  border-bottom: 1px solid #cccccc;
  display: flex;
  align-items: center;

  .el-input--suffix {
    height: 100%;
  }

  input {
    // height: 20px;
    background-color: #fff;
    border: none;
    padding: 0;
  }

  .el-input__icon {
    line-height: 20px;
  }

  &::placeholder {
    color: #ccc;
  }
}

.requiedText {
  color: red;
}
</style>
